import moment from 'moment'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.filter('formatDate', function(value: Date, format:string='DD/MM/YYYY HH:mm',i18n:VueI18n,utc:boolean=false) {
  if (value) {    
    moment.locale(i18n?.locale??"fr")    
    return utc?moment(String(value)).utc().format(format):moment(String(value)).format(format)
  }
})